import { SelectInputWithOperators } from "components/FormControls/SelectInputWithOperators";
import { Field } from "formik";
import _ from "lodash";
import { useMemo } from "react";
import { useStyles } from "./styles";

type StringProps = {
  status?: any;
  fieldName: string;
  index?: number;
  ruleIndex?: number;
  isAchievementForm?: boolean;
  shouldSuppressHj?: boolean;
};

export function String(props: StringProps) {
  const classes = useStyles();
  const valueField = `${props.fieldName}.data`;

  const stringProps = useMemo(
    () => ({
      status: props.status,
      formName: "campaign",
      formFieldName: props.fieldName,
      valueField,
    }),
    [props, valueField],
  );

  return (
    <Field name={props.fieldName}>
      {({ form }: { form: any }) => {
        const { operator, label } = _.get(form.values, props.fieldName);

        const additionalStringProps = {
          currentOperator: operator,
          inputName: label,
        };

        return (
          <SelectInputWithOperators
            {...stringProps}
            {...additionalStringProps}
            className={classes.input}
            isAchievementForm={props.isAchievementForm}
            shouldSuppressHj={props.shouldSuppressHj}
          />
        );
      }}
    </Field>
  );
}
